// document.addEventListener('click', (e) => {
document.addEventListener('DOMContentLoaded', function () {
    // if (e.target.closest('.cat-filter') || e.target.closest('.project-filter')) {

    if (document.querySelector('.cat-filter') || document.getElementById('project-filter-container')) {
        console.log('cat-filter or project-filter')
        const data = new FormData()

        data.append('action', 'load_more')
        data.append('security', liGlobal.loadMore)

        let input = ''
        let postListing = ''
        let postContainer = ''
        let loadMoreBtn = ''

        document.addEventListener('click', (e) => {
            console.log(e.target)

            postListing = e.target.closest('.pc-post-listing')
            postContainer = postListing.querySelector('.post-listing')

            loadMoreBtn = postListing.querySelector('.load-more')

            // 'POST' POST TYPE

            if (e.target.closest('.cat-filter')) {
                console.log('cat-filter')

                let label = e.target.closest('.cat-filter')
                input = label.previousElementSibling

                data.append('post_type', 'post')
                data.append('cat_id', input.value)

                fetchPosts(data)
            }

            if (loadMoreBtn) {
                loadMoreBtnText = loadMoreBtn.querySelector('.load-more-text')
                loadMoreBtn.dataset.catId = input.value

                data.append('card_class', loadMoreBtn.dataset.cardClass)
                data.append('card_body', loadMoreBtn.dataset.cardBody)
            }
        })

        // 'PROJECT' POST TYPE
        if (document.getElementById('project-filter-container')) {
            // const projectFilter = document.getElementById('#project-filter-container');
            console.log('project-filter')

            data.append('post_type', 'project')

            document.querySelectorAll('.filter-button').forEach((button) => {
                button.addEventListener('click', toggleFilterDropdown)
            })

            function toggleFilterDropdown(e) {
                console.log(e.target)
                document.querySelectorAll('.filter-button').forEach((button) => {
                    if (button !== e.target) {
                        button.setAttribute('aria-expanded', false)

                        if (button.nextElementSibling) {
                            button.nextElementSibling.classList.remove('!block')
                        }
                    } else {
                        if (button.getAttribute('aria-expanded') === 'true') {
                            button.setAttribute('aria-expanded', false)
                            button.nextElementSibling.classList.remove('!block')
                        } else {
                            button.setAttribute('aria-expanded', true)
                            button.nextElementSibling.classList.add('!block')
                        }
                    }
                })
            }

            // Close filter dropdowns when clicking outside
            document.addEventListener('click', function (e) {
                // console.log(e.target);
                if (!e.target.closest('.project-filter')) {
                    document.querySelectorAll('.filter-dropdown').forEach((dropdown) => {
                        dropdown.classList.remove('!block')
                    })

                    document.querySelectorAll('.filter-button').forEach((button) => {
                        button.setAttribute('aria-expanded', false)
                    })
                }
            })

            // Filter checkboxes
            const projectCategories = document.querySelectorAll('#project-category-filter input[type="checkbox"]')
            const projectStatus = document.querySelectorAll('#status-filter input[type="checkbox"]')
            const projectGoals = document.querySelectorAll('#goals-filter input[type="checkbox"]')

            let selectedProjectCategories = []
            let selectedProjectStatus = []
            let selectedProjectGoals = []

            // Add event listeners to checkboxes
            projectCategories.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    if (selectedProjectCategories.includes(checkbox.value)) {
                        selectedProjectCategories = selectedProjectCategories.filter(
                            (entry) => entry !== checkbox.value
                        )
                    } else {
                        selectedProjectCategories.push(checkbox.value)
                    }
                    console.log(selectedProjectCategories)
                    if (data.has('project_cat_ids')) {
                        data.delete('project_cat_ids')
                    }
                    data.append('project_cat_ids', selectedProjectCategories)
                    console.log(data)
                    fetchPosts(data)
                })
            })

            projectStatus.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    if (selectedProjectStatus.includes(checkbox.value)) {
                        selectedProjectStatus = selectedProjectStatus.filter((entry) => entry !== checkbox.value)
                    } else {
                        selectedProjectStatus.push(checkbox.value)
                    }
                    console.log(selectedProjectStatus)
                    if (data.has('project_status')) {
                        data.delete('project_status')
                    }
                    data.append('project_status', selectedProjectStatus)
                    fetchPosts(data)
                })
            })

            projectGoals.forEach((checkbox) => {
                checkbox.addEventListener('change', function () {
                    if (selectedProjectGoals.includes(checkbox.value)) {
                        selectedProjectGoals = selectedProjectGoals.filter((entry) => entry !== checkbox.value)
                    } else {
                        selectedProjectGoals.push(checkbox.value)
                    }
                    console.log(selectedProjectGoals)
                    if (data.has('project_goals')) {
                        data.delete('project_goals')
                    }
                    data.append('project_goals', selectedProjectGoals)
                    console.log(data)
                    fetchPosts(data)
                })
            })

            // fetchPosts(data);
        }

        // fetchPosts(data);

        function fetchPosts(data) {
            fetch(liGlobal.ajaxUrl, {
                method: 'POST',
                body: data,
            })
                .then((response) => response.text())
                .then((response) => {
                    response = JSON.parse(response)
                    if (!response.success) {
                        return
                    }

                    if (loadMoreBtn) {
                        if (response.data.load_more_btn_text === 'Inga fler inlägg') {
                            loadMoreBtn.setAttribute('disabled', 'disabled')
                            loadMoreBtn.classList.remove('loading')
                        } else {
                            loadMoreBtn.removeAttribute('disabled')
                        }

                        loadMoreBtnText.textContent = response.data.load_more_btn_text
                    }

                    const posts = response.data.posts
                    postContainer.innerHTML = ''
                    posts.forEach((post) => {
                        postContainer.insertAdjacentHTML('beforeend', post)
                    })
                })
        }
    }
})
